<template>
  <div class="page">
    <div class="content">
      <el-form class="searchBox">
        <el-row>
          <el-col :span="3">
            <el-form-item label="类型" :label-width="'60px'">
              <el-select
                style="width: 100px"
                class="select"
                v-model="operTypeId"
                placeholder="请选择"
                size="small"
                @change="clickSearch"
              >
                <el-option
                  v-for="item in [
                    { label: '入住', value: '2' },
                    { label: '移出', value: '3' },
                    { label: '创建', value: '1' },
                    {
                      label: '更新状态',
                      value: '4',
                    },
                  ]"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="3">
            <el-form-item label="门店" :label-width="'60px'">
              <el-select
                :disabled="!$buttonAuthority('huoti-pethouse-shop')"
                style="width: 100px"
                class="select"
                v-model="shopId"
                placeholder="请选择"
                size="small"
                @change="clickSearch"
              >
                <el-option
                  v-for="item in shops"
                  :key="item.shop_id"
                  :label="item.shop_name"
                  :value="item.shop_id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="时间" :label-width="'90px'">
              <el-date-picker
                type="daterange"
                v-model="timer"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                size="small"
                style="width: 220px"
                @change="clickSearch"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="4" style="text-align: right">
            <resetBtn
              @reset="reset"
              style="width: 56px; display: inline-block; margin: 0px 10px"
            ></resetBtn>
          </el-col>
        </el-row>
      </el-form>
      <el-table :data="tableData" style="width: 100%">
        <el-table-column label="类型">
          <template slot-scope="scope">
            <div v-if="scope.row.cageOperType">
              {{ scope.row.cageOperType ? scope.row.cageOperType.title : "" }}
            </div>
          </template>
        </el-table-column>
        <!-- <el-table-column label="更改门店">
        
        </el-table-column> -->
        <el-table-column label="时间">
          <template slot-scope="scope">
            {{ $public.FTime(scope.row.operTime) }}
          </template>
        </el-table-column>
        <el-table-column label="操作人">
          <template slot-scope="scope">
            {{ scope.row.operUser || "--" }}
          </template>
        </el-table-column>
        <el-table-column label="事件" prop="content"> </el-table-column>
      </el-table>
      <page
        :page="page.page"
        :total="page.total"
        @change="pageChange"
      ></page>
    </div>
  </div>
</template>
  
  <script>
import shopList from "../../../util/shopList";
import resetBtn from "../../../components/resetBtn.vue";
import page from "../../../components/page.vue";
export default {
  components: {
    resetBtn,
    page,
  },
  data() {
    return {
      operTypeId: "",
      shops: shopList,
      page: {
        page: 1,
        pageSize: 10,
        total: 0,
      },
      tableData: [],
      timer: [],
      shopId: this.$store.state.shopId,
    };
  },
  mounted() {
    this.getOperatList();
  },
  methods: {
    // 搜索
    clickSearch() {
      this.page.page = 1;
      this.getOperatList();
    },
    // 重置
    reset() {
      this.timer = [];
      this.operTypeId = "";
      this.page.page = 1;
      this.getOperatList();
    },
    // 页码改变
    pageChange(a) {
      this.page.page = a;
      this.getOperatList();
    },
    // 笼子操作记录
    getOperatList() {
      let params = {
        shopId: this.shopId,
        cageId: "",
        operTypeId: this.operTypeId,
        pageIndex: this.page.page,
        pageSize: this.page.pageSize,
      };
      if (this.timer && this.timer.length == 2) {
        params.startTime = ("" + new Date(this.timer[0]).getTime()).substr(
          0,
          10
        );
        params.endTime = ("" + new Date(this.timer[1]).getTime()).substr(0, 10);
      }
      let loading = this.$loading();
      this.$http
        .post(
          process.env.VUE_APP_Url_8000 + "/api/cage/oper/record/page",
          params
        )
        .then((res) => {
          loading.close();
          // console.log(res, "日志");
          this.page.total = res.data.count;
          this.tableData = res.data.data;
        });
    },
  },
};
</script>
  
  <style scoped lang="scss">
.page {
  .searchView {
    .tabLine {
      display: flex;
      .tabItem {
        width: 88px;
        box-sizing: border-box;
        line-height: 36px;
        text-align: center;
        border-right: 1px solid #f2f2f2;
        cursor: pointer;
        font-size: 14px;
        background-color: #fff;
        &.active {
          color: $mainColor;
        }
      }
    }
    .searchBox {
      border-top: 1px solid #f2f2f2;
    }
  }
  .content {
    padding: 0 0px;
    min-height: 600px;
    ::v-deep .el-form-item {
      margin-bottom: 0;
      .el-form-item__label {
        padding-right: 5px;
        font-size: 12px;
      }
    }
  }
}
</style>